import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/sun': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M494.2 221.9c11.2 7.6 17.8 20.1 17.9 33.7 0 13.4-6.7 26-17.8 33.5l-59.8 40.5 13.7 71c2.5 13.2-1.6 26.8-11.1 36.3s-22.9 13.8-36.3 11.1l-70.9-13.7-40.4 59.9c-7.5 11.1-20.1 17.8-33.5 17.8s-26-6.7-33.5-17.9l-40.4-59.9-70.8 13.7c-13.4 2.6-26.8-1.6-36.3-11.1s-13.7-23.1-11.1-36.3l13.7-71-59.8-40.5c-11.1-7.5-17.8-20-17.8-33.5s6.6-26 17.8-33.6l59.8-40.5-13.7-71c-2.6-13.2 1.6-26.7 11.1-36.3 9.5-9.6 23-13.7 36.3-11.2l70.8 13.7 40.4-59.9c15.1-22.3 51.9-22.3 67 0l40.4 59.9 70.9-13.7c13-2.6 26.6 1.6 36.2 11.1 9.5 9.6 13.7 23.2 11.1 36.4l-13.7 71zM381.3 307.5l76.8-52.1-76.8-52 17.6-91.1-91 17.6-51.9-76.9-51.8 76.8-91-17.6 17.6 91.2-76.8 52 76.8 52-17.6 91.2 90.9-17.6 51.9 77 51.9-76.9 91 17.6zM256 152c57.3 0 104 46.7 104 104s-46.7 104-104 104-104-46.7-104-104 46.7-104 104-104zM256 312c30.9 0 56-25.1 56-56s-25.1-56-56-56-56 25.1-56 56 25.1 56 56 56z'
      }
    ]
  }
})
